var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 80,
    viewBox: "0 0 77 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0043 46.2246C41.421 48.0259 35.3966 51.3418 30.8354 47.1913C26.2658 43.033 27.2032 35.4138 30.593 30.9345C34.6173 25.6169 42.1264 23.4167 48.3644 25.9399C59.8016 30.5661 62.4876 45.0724 60.6943 55.7481C56.6845 79.6188 28.914 79.191 14.3803 63.6698C-0.255548 48.0395 4.11233 17.7588 23.5915 8.70309C42.5531 -0.112019 59.3244 10.1207 71.8226 23.9011",
    stroke: "#FFDCA2",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleServices);
export default __webpack_public_path__ + "static/media/circle-services.f5b1484e6a00542b4bc0b6ce82e433a1.svg";
export { ForwardRef as ReactComponent };